import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import  api from '../common/api';
import  MediaFile from '../common/MediaFile';
import LinearProgress from '@material-ui/core/LinearProgress';

class SubcontactImport extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
          loaded: false,
          dialogOpen: false,
          contact:{provider:{business_name:''}, client:{business_name:''}},
          files:[]
		}
  	}

  	componentDidMount(){
  		var parent_contact_id = this.props.match.params.contact_id
  		this.setState({parent_contact_id})
	    this.getContact(parent_contact_id)

  	}

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

  	handleDownloadTemplate = () => {
        window.location.href = api.subcontacts_import_template
  	}

	handleSubmit = (e) => {
    	e.preventDefault();
	    var formData = new FormData();
		var i = 0;
		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.set("import", val.file[0])
					i++;
				}	
			})
		}
	    formData.set("parent_contact_id", this.state.parent_contact_id);
	    var errors =[]
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(api.subcontacts().import(),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		this.setState({excel_loaded:true, message: response.data.message })
	      })
	      .catch(function (error) {
				var promise = new Promise(function(resolve, reject) {
					resolve(error.response.data);
					errors = error.response.data
		  		});
				self.setState({errors:errors, files:[], excel_loaded:true})		  		

	    })
	}

  	getContact(contact_id){
	    const token = localStorage.getItem('userToken')

	    var results =  axios
	        .all([
	              axios.get(api.contacts().get(contact_id),{ headers: {"Authorization" : `Bearer ${token}`} }),
	        ])
	        .then(
	        axios.spread((...responses) => {
	          const contact = responses[0].data;
	              this.setState({
	                  contact,
	                  loaded:true
	              })
	            }))
  	}


  	render(){
	    const handleRedirect = id => () => {
	      window.location.href='/subcontacts/'+this.state.parent_contact_id
	    }
	    var errors = []
	    if (this.state.errors){
	    	var messages = Object.values(this.state.errors.message)
      		messages.map((val,idx)=>{
      			var rows = Object.keys(val)
      			rows.map((val2,idx2)=>{
	      			var fields = Object.values(val[val2])
	      			fields.map((val3,idx3)=>{
	      				var message = 'La linea ' + val2 + ': '+val3[0]
	      				errors.push(message)
	      				/*return (
	          				<div style={{color: 'red'}}>Línea {row}: {val2[0]}</div>
	  					)*/
	      			})

      			})

      		})
	    }
	    const business_name = (this.state.contact.provider !== null )? this.state.contact.provider.business_name : this.state.contact.client.business_name 
  		return(
	         <Container fluid className="main-content-container px-4 pb-4">
	            <Row noGutters className="page-header pt-4">
	              <PageTitle lg="12" title={"Alta masiva de "+business_name} className="text-lg-left" />
	            </Row>
				<Row>
				<Col md="12">
				  <React.Fragment>
			      <div className="mt-2">
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              	(this.state.excel_loaded)
	              	?
		              	(this.state.errors) ?
		              		errors.map((val,idx2)=>{
		              			return (
		              				<div className="mt-1">{val}</div>
		          				)
		              		})
		              	:
		              	<div>{this.state.message}</div>
		            :
						<React.Fragment>
							<MediaFile onChange={this.handleUploadFile} title="Agregar excel" width={"15rem"} height={"2rem"}  meta_data="comprobante" />
							<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>Cargar</Button>
						</React.Fragment>
				  }			  
				<Button className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleDownloadTemplate()}}>Descargar Template</Button>
				<Button className="mt-2" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {window.location.href='/subcontacts/' + this.state.parent_contact_id}}>Volver</Button>
				</div>
	            </React.Fragment>
	          </Col>
	        </Row>
	      </Container>

		)
  	}

}
export default SubcontactImport;
